import getInfoFromURL from './getInfoFromURL'
import fetchAndSetSiteInfo from './fetchAndSetSiteInfo'
import * as UrlBuilder from './urlBuilder'
export default function (dontFetchSiteInfo = false) {
  // DE Locale
  // make call to checkState to create marc session for logged in users
  const tokenData = window.AwsAuth.currentSessionData

  if (tokenData) {
    const [urlPrefix, , , , headers] = getInfoFromURL()

    const baseUrl = UrlBuilder.getBaseUrl(urlPrefix)
    const url = `${baseUrl}/api/v2/login/checkState`

    const promise = window.fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenData.idToken.jwtToken}`,
        ...headers
      }
    })

    if (!dontFetchSiteInfo) {
      promise
        .then(fetchAndSetSiteInfo)
        .catch(fetchAndSetSiteInfo)
    }
  }
}
